"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _interopRequireWildcard = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _DaoServiceClientES6Adapter = _interopRequireWildcard(require("@/utils/daoService/DaoServiceClientES6Adapter"));
var _request = _interopRequireDefault(require("@/utils/request"));
var sysFile = _DaoServiceClientES6Adapter.default.QSysFileInfo.using(_DaoServiceClientES6Adapter.dsc);
var pre = '/sitceb-system-service';

/* 获取文件列表 */
sysFile.getFileListById = function (query) {
  if (query.referenceId && query.referenceId[0] !== null) {
    query.deleteFlag = 0;
    // console.log('query', query)
    return sysFile.select(sysFile.fieldContainer()).where(sysFile.referenceId.in(_DaoServiceClientES6Adapter.___).and(sysFile.deleteFlag.eq(_DaoServiceClientES6Adapter.___)).and(sysFile.businessCode.in(_DaoServiceClientES6Adapter.___)).and(sysFile.subBusinessCode.eq(_DaoServiceClientES6Adapter.___))).sorting(sysFile.sequence).tag('getFileListById').execute(query);
  } else {
    return new Promise(function (resolve, reject) {
      reject({
        success: false,
        errorMessages: ['referenceId不可为空']
      });
    });
  }
};
/* 获取文件列表-关联user表得到上传人名称,关联office表得到部门名称 */
sysFile.getFileList = function (query) {
  if (query.referenceId && query.referenceId[0] !== null) {
    query.deleteFlag = 0;
    query.currentPage = 1;
    query.pageSize = 999999;
    // console.log('query', query)
    // return sysFile.select(sysFile.fieldContainer()
    //   .append(sysFile.sysOffice.chain(sysOffice.officeName).as('officeNameCn'))
    //   .append(sysFile.sysOffice.chain(sysOffice.officeNameEn).as('officeNameEn'))
    //   .append(sysFile.sysUser.chain(sysUser.userNameCn).as('userNameCn'))
    //   .append(sysFile.sysUser.chain(sysUser.userNameEn).as('userNameEn')))
    //   .where(sysFile.referenceId.in(___).and(sysFile.deleteFlag.eq(___))
    //     .and(sysFile.businessCode.in(___))
    //     .and(sysFile.subBusinessCode.eq(___)))
    //   .sorting(sysFile.sequence)
    //   .tag('getFileList')
    //   .execute(query)
    return new Promise(function (resolve, reject) {
      _DaoServiceClientES6Adapter.dsc.customCommand('getFileListByCustom').tag('getFileListByCustom').paging(query.currentPage, query.pageSize).execute(query, function (res) {
        if (res.success) {
          resolve({
            success: true,
            data: res.data.records
          });
        } else {
          reject(res);
        }
      });
    });
  } else {
    return new Promise(function (resolve, reject) {
      reject({
        success: false,
        errorMessages: ['referenceId不可为空']
      });
    });
  }
};
sysFile.getDashboardFileList = function (query) {
  return new Promise(function (resolve, reject) {
    _DaoServiceClientES6Adapter.dsc.customCommand('getDashboardFileList').paging(query.currentPage, query.pageSize).tag('getDashboardFileList').execute(query, function (res) {
      if (res.success) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
};
sysFile.deleteFileById = function (id) {
  return sysFile.deleteById(id);
};
/* 获取文件 */
sysFile.getFileById = pre + '/filesystem/downloadFile/';

/* 获取文件scr */
sysFile.getFileSrc = function (id) {
  return (0, _request.default)({
    url: pre + '/filesystem/downloadFile/' + id,
    method: 'get',
    responseType: 'blob'
  });
};
/* 查看原图 */
sysFile.viewOriginImage = function (id) {
  return (0, _request.default)({
    url: pre + '/filesystem/downloadFile/' + id + '?fileType=ORIGINAL_FILE',
    method: 'get',
    responseType: 'blob'
  });
};

/* 绑定关系 */
sysFile.bindFileRelation = function (data) {
  return (0, _request.default)({
    url: pre + '/api/update?updateSyncFlag=' + data[0].syncFlag,
    method: 'post',
    data: data
  });
};
/* 删除附件 */
sysFile.deleteFile = function (data) {
  return (0, _request.default)({
    url: pre + '/api/deleteFile/' + data,
    method: 'post'
  });
};

/* 新增附件 */
sysFile.newFile = function (data) {
  return (0, _request.default)({
    url: pre + '/api/newFile',
    method: 'post',
    data: data
  });
};

/* 重发原图 */
sysFile.resendOriginImage = function (query) {
  return (0, _request.default)({
    url: pre + '/doResendImageFile',
    method: 'get',
    params: query
  });
};

/* 新增保存 */
sysFile.saveFiles = function (data) {
  return sysFile.save(data);
};
sysFile.getSystemPractice = function (companyId, businessId) {
  return (0, _request.default)({
    url: '/immp/qualityDoc/getFileListByBusinessCode/' + companyId + '/' + businessId,
    method: 'get'
  });
};
sysFile.getById = function (id) {
  return sysFile.selectOne().byId(id);
};
sysFile.getFileByRefCode = function (referenceId, businessCode) {
  if (referenceId) {
    return sysFile.select().where(sysFile.referenceId.eq$(referenceId).and(sysFile.businessCode.eq$(businessCode))).execute();
  } else {
    return new Promise(function (resolve, reject) {
      reject({
        success: false,
        errorMessages: ['referenceId不可为空']
      });
    });
  }
};

/* 获取文件scr */
sysFile.getFileByReferenceIdAndBusinessCode = function (data) {
  return (0, _request.default)({
    url: pre + '/api/downloadFileByReferenceIdAndBusinessCode',
    method: 'get',
    responseType: 'blob',
    params: data
  });
};
sysFile.getFileListByReferenceIdNew = function (data) {
  return (0, _request.default)({
    url: pre + '/api/getFileListByReferenceIdNew',
    method: 'post',
    data: data
  });
};
/* 通过文件id批量查询 */
sysFile.getFileListByFileIds = function (data) {
  return (0, _request.default)({
    url: pre + '/filesystem/getFileListByFileIds',
    method: 'post',
    data: data
  });
};
var _default = exports.default = sysFile;